// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Countdown.css */

.countdown-container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.countdown-number {
  font-family: "Bebas Neue", sans-serif;
  font-size: 10rem;
  color: #000000;
  text-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

@keyframes countdown {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Countdown.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAG7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF","sourcesContent":["/* src/styles/Countdown.css */\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n\n.countdown-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.countdown-number {\n  font-family: \"Bebas Neue\", sans-serif;\n  font-size: 10rem;\n  color: #000000;\n  text-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  transition: all 0.3s ease;\n}\n\n@keyframes countdown {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
